import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1084f5b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Linking Twitter", -1))

import { inject, onMounted, Ref } from 'vue';
import { useRouter } from 'vue-router';
import { getCookie } from 'tiny-cookie';
import { useUserStore } from '@/store/users';
import { AlertModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();

const alertModal = inject('alertModal') as Ref<AlertModal>;

onMounted(async () => {
  const main = window.location.href.split('#')[0];
  const sub = main.split('?')[1];
  const parts = sub.split('&');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const body: any = {
    r_token: getCookie('twitoken'),
  };
  let subparts = parts[0].split('=');
  [, body[subparts[0]]] = subparts;
  subparts = parts[1].split('=');
  [, body[subparts[0]]] = subparts;
  await userStore.linkTwitterAccountCallback({
    ...body,
    token: getCookie('pws-jwt'),
  });

  window.history.replaceState({}, document.title, window.location.pathname);
  router.push('/account');
  alertModal.value.show(
    'Twitter Linked',
    'You have successfully linked a Twitter account to your Prowess account. You can now login with your Twitter account.'
  );
});

return (_ctx: any,_cache: any) => {
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, { class: "loader" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_b_spinner)
    ]),
    _: 1
  }))
}
}

})